export default {"src":"/_next/static/media/dogEmergency_64.270b79f5.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};